<template>
    <section>
        <modal ref="modalCederClientes" titulo="Ceder clientes a otro vendedor" no-aceptar adicional="Ceder" @adicional="agregar">
            <div class="row mx-0">
                <cargando v-if="cargando" />
                <div class="col px-0">
                    <div class="row justify-center mt-3">
                        <div class="col-10 text-general">
                            Ceder todos los clientes de <strong>{{ tienda.propietario_nombre }}</strong> a otro {{$config.vendedor}}.
                        </div>
                    </div>
                    <div class="row justify-center mt-3">
                        <div class="col-10 text-general">
                            <p class="f-13 ml-2">Seleccionar {{$config.vendedor}}</p>
                            <el-select v-model="leechero" class="w-100" placeholder="Selecciona" size="small" :clearable="true" :filterable="true" :filter-method="getLeecheros" @clear="limpiar" @change="seleccionarLeechero">
                                <el-option
                                v-for="item in leecheros"
                                :key="item.id"
                                :label="item.nombre"
                                :value="item.id"
                                />
                            </el-select>
                        </div>
                    </div>
                    <template v-if="mostrarLeechero">
                        <div class="row justify-center mt-3">
                            <img :src="leecheroSeleccionado.logo" class="br-5 border obj-cover" style="width:110px;height:110px;" />
                            <div class="col-6 text-general">
                                <p class="text-general mt-1 f-500">
                                    {{ leecheroSeleccionado.nombre }}
                                </p>
                                <p class="text-general2 f-13">
                                    <i class="icon-calendar-outline f-19" />
                                    {{$config.vendedor}} desde {{ leecheroSeleccionado.created_at | helper-fecha('D MMM YYYY') }}
                                </p>
                                <p class="text-general2 f-13">
                                    <i class="icon-cliente f-19" />
                                    {{ leecheroSeleccionado.total_clientes }} Clientes
                                </p>
                            </div>
                        </div>
                        <div class="row justify-center mt-5">
                            <div class="col-10 text-general">
                                Los <strong>{{ totalClientesLeechero }}</strong> clientes de <strong>{{ tienda.propietario_nombre }}</strong>  pasarán a hacer atendidos por <strong>{{ leecheroSeleccionado.nombre }}</strong>.
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </modal>
    </section>
</template>
<script>
import Service from "~/services/clientes"
import Produccion from "~/services/tiendas/produccion";
export default {
    data(){
        return{
            cargando: false,
            mostrarLeechero: false,
            leecheros: [],
            leecheroSeleccionado: {},
            tienda: {},
            leechero: '',
            totalClientesLeechero: 0,
        }
    },
    computed: {
        idTienda(){
            return Number(this.$route.params.id_tienda)
        }
    },
    methods: {
        toggle(clientes){
            console.log(clientes);
            this.limpiar();
            this.info_tienda();
            this.totalClientesLeechero = clientes.clientesTotales;
            this.$refs.modalCederClientes.toggle();
        },
        async info_tienda(){
            try {
                const { data } = await Produccion.info_tienda(this.$route.params.id_tienda)
                this.tienda = data.info;
            } catch (error){
                this.error_catch(error)
            }
        },
        async getLeecheros(query){
            try {
                if(query.length < 3)return;
                const params = {
                    query: query
                };
                const {data} = await Service.getLeecheros(params);
                this.leecheros = data.leecheros;
            } catch(error){
                this.error_catch(error)
            }
        },
        async agregar(){
            try {
                this.cargando = true;
                const form = {
                    leechero_entrega: this.idTienda,
                    leechero_recibe: this.leechero
                };
                const { data } = await Service.postCederClientesLeechero(form);
                this.notificacion('Mensaje', data.mensaje, data.tipo);
                this.$emit('actualizar');
                this.$refs.modalCederClientes.toggle();
            } catch(error){
                this.error_catch(error)
            } finally {
                this.cargando = false;
            }
        },
        async seleccionarLeechero(){
            let data = this.leecheros.find((element) => element.id === this.leechero);
            if(data){
                this.leecheroSeleccionado = data;
                this.mostrarLeechero = true;
            }
        },
        async limpiar(){
            this.mostrarLeechero = false;
            this.leechero = "";
            this.totalClientesLeechero = 0;
            this.leecheros = [];
            this.leecheroSeleccionado = {};
        },
    }
}
</script>
